import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    SPMSGetShiftPlanResponse
} from "../../types/shiftPlan";
import { RootState } from "../types";

export interface GetAllShiftPlansState {
    shiftPlans: SPMSGetShiftPlanResponse[] | null;
}

const initialState: GetAllShiftPlansState = {
    shiftPlans: null,
}

export interface setShiftPlansPayload {
    shiftPlans: SPMSGetShiftPlanResponse[];
}

const getAllShiftPlansSlice = createSlice({
    name: 'getAllShiftPlans',
    initialState,
    reducers: {
        setShiftPlans: (state, action: PayloadAction<setShiftPlansPayload>) => {
            state.shiftPlans = action.payload.shiftPlans;
        }
    }
});

export const { setShiftPlans } = getAllShiftPlansSlice.actions;

export default getAllShiftPlansSlice.reducer;

export const selectAllShiftPlans = (state: RootState) => state.getAllShiftPlans.shiftPlans;